var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3347 25.6651C12.8884 25.2188 12.8884 24.4952 13.3347 24.0489L19.3837 17.9999L13.3347 11.9509C12.8884 11.5045 12.8884 10.7809 13.3347 10.3346C13.781 9.8883 14.5046 9.8883 14.9509 10.3346L21.8081 17.1918C22.2544 17.6381 22.2544 18.3617 21.8081 18.808L14.9509 25.6651C14.5046 26.1115 13.781 26.1115 13.3347 25.6651Z",
    fill: "#0542C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderarrow);
export default __webpack_public_path__ + "static/media/sliderarrow.426f5f0aad71a0b19707c4a27aa8038e.svg";
export { ForwardRef as ReactComponent };